export const appsAppGroupIdChartsCustomEventNames = "/apps/:app_group_id/charts/custom_event_names";
